export default "__VITE_ASSET__c764e795__"